import { render, staticRenderFns } from "./NoPermission403.vue?vue&type=template&id=5c23df5a&scoped=true&lang=html&"
import script from "./NoPermission403.vue?vue&type=script&lang=js&"
export * from "./NoPermission403.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c23df5a",
  null
  
)

export default component.exports